import { render } from "./StudentList.vue?vue&type=template&id=1b75709f&scoped=true"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"

import "./StudentList.vue?vue&type=style&index=0&id=1b75709f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b75709f"]])

export default __exports__